var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { superBoxStyle } from '@vital-ui/react-utils';
import cn from 'classnames';
import { defaultTheme } from '@vital-ui/react-theme';
import fieldBase from '../components/FieldBase';
export var Input = styled.input.attrs(function (props) { return ({
    className: cn('vital__input', props.className),
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ",
    ";\n"])), fieldBase, superBoxStyle, function (props) {
    return props.theme.form.inputStyle && props.theme.form.inputStyle;
});
Input.defaultProps = {
    theme: defaultTheme,
};
var templateObject_1;
//# sourceMappingURL=Input.js.map